import { StarterCallback } from "@/starter";

const _resetOnresize: StarterCallback = (app) => {
  const store = app.config.globalProperties.$store;
  window.onresize = (evt) => {
    store.dispatch("window/onresize/updateTimestamp", evt);
  };
  Object.defineProperty(window, "onresize", {
    configurable: false,
    writable: false,
  });
};

// IOS系统的viewpoint无效，通过js来控制屏幕的手动放大与缩小操作。
const _forbidScreenZoomInAndZoomOut = () => {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });

  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    function (event) {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};

/**
 * 初始化全局变量window，修改window部分属性的默认行为。
 */
export const initWindow: StarterCallback = (app) => {
  _resetOnresize(app);

  window.onload = function () {
    _forbidScreenZoomInAndZoomOut();
  };
};
